import { useForm } from '@/common/form/FormContext';
import { useMemo } from 'react';

// The reqParam the Test Dashboard sends to TEST_DASHBOARD_RESULTS_DATA_PLUGIN, built from the filter form
export const useTestDashboardReqParam = () => {
  const { formValues } = useForm();

  return useMemo(
    () => ({
      suiteCode: formValues.suiteCode,
      testCode: formValues.testCode,
      rqmtCode: formValues.rqmtCode,
    }),
    [formValues.suiteCode, formValues.testCode, formValues.rqmtCode],
  );
};
